import React, { useState } from "react";
import Navbar from "../components/framepart/Navbar/Navbar";
import Sidebar from "../components/framepart/Sidebar/Sidebar";
import MainPanel from "../components/framepart/MainPanel/MainPanel";
import Footer from "../components/framepart/Footer/Footer";
import "../styles/main.css";
import * as CanevaModules from "../pages/masterpages/caneva";
import { Background } from "reactflow";

const NAVBAR_HEIGHT = 45;
const FOOTER_HEIGHT = 40;

const LayoutCaneva = () => {
  const [ActiveComponent, setActiveComponent] = useState(
    () => CanevaModules.Page_101_mockup
  );

  console.log(ActiveComponent);

  const sidebarItems = [
    { label: "Config", icon: "/assets/icones/caneva/breakdown.svg", component: CanevaModules.Page_101_mockup },
    { label: "Builder", icon: "/assets/icones/caneva/project.svg", component: CanevaModules.Page_102_architecture },
    { label: "Builder", icon: "/assets/icones/caneva/project.svg", component: CanevaModules.Page_102_beta },
    { label: "Activity", icon: "/assets/icones/caneva/timeline.svg", component: CanevaModules.Page_110 },
    { label: "Specifications", icon: "/assets/icones/caneva/specifications.svg", component: CanevaModules.Page_104 },
    { label: "Budget", icon: "/assets/icones/caneva/budget.svg", component: CanevaModules.Page_107 },
  ];

  return (
    <div
      className="page-container"
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100vh",
        minWidth: 0,
        minHeight: 0,
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          height: NAVBAR_HEIGHT,
          minHeight: NAVBAR_HEIGHT,
          flex: "0 0 auto",
          minWidth: 0,
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Navbar
          logo={{ src: "/assets/logos/corelia.png", label: "Quantum Corelia" }}
          toolbar={<div style={{ display: "flex", gap: 6 }}>Outils</div>}
        />
      </div>

      <div
        className="Middle-container"
        style={{
          flex: "1 1 auto",
          width: "100%",
          minWidth: 0,
          minHeight: 0,
          display: "flex",
          alignItems: "stretch",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        <div
          className="Side-container"
          style={{
            height: "100%",
            minWidth: 0,
            minHeight: 0,
            boxSizing: "border-box",
            backgroundColor: "transparent",
            flexShrink: 0,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Sidebar
            items={sidebarItems}
            onItemClick={(component) => setActiveComponent(() => component)}
            style={{
              height: "100%",
              minWidth: 0,
              minHeight: 0,
              boxSizing: "border-box",
              backgroundColor: "transparent",
              overflow: "hidden",
            }}
          />
        </div>

        <div
          className="Center-container"
          style={{
            flex: "1 1 auto",
            width: "100%",
            height: "100%",
            minWidth: 0,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            boxSizing: "border-box",
          }}
        >
          <MainPanel
            style={{
              flex: "1 1 auto",
              width: "100%",
              height: "100%",
              minWidth: 0,
              minHeight: 0,
              overflow: "hidden",
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {ActiveComponent && <ActiveComponent />}
          </MainPanel>
        </div>
      </div>

      <div
        style={{
          height: FOOTER_HEIGHT,
          minHeight: FOOTER_HEIGHT,
          padding: 0,
          margin: 0,
          flex: "0 0 auto",
          minWidth: 0,
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Footer />
      </div>
    </div>
  );
};

export default LayoutCaneva;